import { Router } from 'next/router';
import Script from 'next/script';
import { useEffect } from 'react';

import * as snippet from '@segment/snippet';

import { IS_DEVELOPMENT, SEGMENT_KEY } from '@/constants/env';
import { useAppSelector } from '@/redux/hooks';

function renderSnippet(): string {
  const opts: snippet.Options = {
    apiKey: SEGMENT_KEY,
    page: true,
  };

  if (IS_DEVELOPMENT) {
    return snippet.max(opts);
  }

  return snippet.min(opts);
}

export default function SegmentScript() {
  if (!SEGMENT_KEY) return null;
  return <Script dangerouslySetInnerHTML={{ __html: renderSnippet() }} id="segment-script" />;
}

export const SegmentPageListener: React.FC = () => {
  const user = useAppSelector((state) => state.auth.user);

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      if (url) {
        //@ts-ignore
        window.analytics?.page();
      }
    };

    Router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);

  useEffect(() => {
    //@ts-ignore
    if (window.analytics && user) {
      //@ts-ignore
      window.analytics.identify(user.userid, {
        email: user.email,
        firstName: user.first_name,
        lastName: user.last_name,
      });
    }
  }, [user]);

  return null;
};
